import { AWSS3Image } from "./AWSS3Image.model";

export class MenuItemCatalogModel {
  id: number;
  menu_item_id: number;
  menu_item_catalog_group_id: number;
  priority: number;
  name: string;
  description: string;
  images: AWSS3Image[];
  restricted_menu_item_capacities: number[];
  terms_and_conditions: string;
  usage_terms: string;
  starting_date: Date;
  ending_date: Date;
  inventory: number;
  capacity_type: string;
  expire_period_type: string;
  expire_period: number;

  constructor(id = 0,
    menu_item_id = 0,
    menu_item_catalog_group_id = 0,
    priority = 0,
    name = '',
    description = '',
    restricted_menu_item_capacities = [],
    terms_and_conditions = '',
    usage_terms = '',
    starting_date = new Date(),
    ending_date = new Date(),
    inventory: 0,
    capacity_type: '',
    expire_period_type: '',
    expire_period: 0
  ) {
    this.id = id;
    this.menu_item_id = menu_item_id;
    this.menu_item_catalog_group_id = menu_item_catalog_group_id;
    this.priority = priority;
    this.name = name;
    this.description = description;
    this.restricted_menu_item_capacities = restricted_menu_item_capacities;
    this.terms_and_conditions = terms_and_conditions;
    this.usage_terms = usage_terms;
    this.starting_date = starting_date;
    this.ending_date = ending_date;
    this.inventory = inventory;
    this.capacity_type = capacity_type;
    this.expire_period_type = expire_period_type;
    this.expire_period = expire_period;
  }
}
